import {$$} from './util';

(function () {
    $$('.embed__video').forEach(embed => {
        let youtube = JSON.parse(embed.dataset.yt);
        embed.addEventListener('click', injectIframe);

        function injectIframe() {
            embed.classList.remove('play-icon');
            let url = `http://www.youtube.com/embed/${youtube.id}?${serialize(youtube)}`;
            let iframe = document.createElement('iframe');
            iframe.src = url;
            embed.innerHTML = iframe.outerHTML;

            embed.removeEventListener('click', injectIframe);
        }
    });

    function serialize(obj) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }
})();


// WEBPACK FOOTER //
// ./js/embed.js